import { useEffect, useState } from "react";

/**
 * participant track subscription
 */
export default function useTrackSubscription({ participant }) {
  const [videoTrack, setVideoTrack] = useState(null);
  const [audioTrack, setAudioTrack] = useState(null);

  useEffect(() => {
    if (participant) {
      /**
       * participant track subs
       */

      const trackSubscribed = (track) => {
        if (track.kind === "video") {
          setVideoTrack(track);
        } else if (track.kind === "audio") {
          setAudioTrack(track);
        }
      };

      participant.tracks.forEach((publication) => {
        if (publication.track) {
          trackSubscribed(publication.track);
        }
      });

      participant.on("trackSubscribed", (track) => trackSubscribed(track));

      participant.on("trackPublished", (track) => trackSubscribed(track));

      /**
       * participant track unsubs
       */
      const trackUnsubscribed = (track) => {
        console.log("unpub");
        if (track.kind === "video") {
          setVideoTrack(null);
        } else if (track.kind === "audio") {
          setAudioTrack(null);
        }
      };
      participant.on("trackUnsubscribed", (track) => trackUnsubscribed(track));
      participant.on("trackUnpublished", (track) => trackUnsubscribed(track));
      return () => {
        participant.off("trackSubscribed", trackSubscribed);
        participant.off("trackUnsubscribed", trackUnsubscribed);
        participant.off("trackPublished", () => console.log("trackPublished"));
      };
    }
  }, [participant]);

  return { audioTrack, videoTrack };
}
